<template>
    <div class="file-upload">
        <slot name="prefix">
            <input type="text" readonly v-if="hasValue" class="field-value" :value="value" />
        </slot>
        <button class="field-button" :class="{ 'loading': loading }" @click="onClickUpload">
            <span class="content">
                <slot>上传文件</slot>
            </span>
        </button>
        <form style="display: none" ref="uploadFileForm">
            <input type="file" ref="uploadFileInput" style="display: none" @change="onUploadFileChange" />
        </form>
    </div>
</template>


<script>
import _ from 'lodash'

export default {
    model: {
        prop: "value",
        event: "input",
    },
    props: {
        value: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            loading: false,
        }
    },
    computed: {
        hasValue() {
            return !_.isNil(this.value) && this.value !== "";
        }
    },
    methods: {
        onClickUpload() {
            if (this.loading) { return }
            let el = this.$refs.uploadFileInput;
            if (!_.isNil(el)) {
                el.click();
            }
        },
        async _uploadFile(files) {
            this.loading = true
            this.$emit("upload", {
                files,
                done: () => {
                    this.loading = false
                    let form = this.$refs.uploadFileForm;
                    form.reset();
                }
            });
        },
        async onUploadFileChange() {
            let el = this.$refs.uploadFileInput;
            if (_.isNil(el) || el.files.length <= 0) {
                return;
            }
            await this._uploadFile(el.files);
        },
    },
}
</script>


<style lang="less" scoped>
@import '~@/styles/common';

.file-upload {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    overflow: hidden;

    .field-value {
        flex: 1;
        max-width: 240px;
        margin-right: 16px;
        border: none;
        outline: none;
        text-overflow: ellipsis;
        overflow: hidden;
        color: @antTextSemi;
    }

    .field-button {
        position: relative;
        display: flex;
        height: 32px;
        border-radius: 8px;
        border: solid 1px @antBlue;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        min-width: auto;
        text-decoration: none;
        color: @antBlue;
        background-color: @antBackWhite;
        cursor: pointer;

        .content {
            display: inline-block;
            padding-left: 8px;
            padding-right: 8px;
        }

        &.loading {
            opacity: 0.9;
            cursor: progress;

            .content {
                padding-left: 16px;
                padding-right: 0px;
            }
        }

        &.loading .content {
            position: relative;
        }

        &.loading .content::after {
            content: '';
            position: absolute;
            width: 8px;
            height: 8px;
            top: 0;
            left: 0;
            bottom: 0;
            margin: auto;
            border: 3px solid transparent;
            border-top-color: @antBlue;
            border-radius: 50%;
            animation: file-upload-button-loading-spinner 1s ease infinite;
        }
    }
}

@keyframes file-upload-button-loading-spinner {
    from {
        transform: rotate(0turn);
    }

    to {
        transform: rotate(1turn);
    }
}
</style>